import { SignupForm } from '@/components/signup-form'
import { trpc } from '@/lib/trpc'
import { useNavigate } from 'react-router-dom'

export function SignUpPage() {
  const navigate = useNavigate()
  const utils = trpc.useUtils()

  async function onSuccess() {
    await utils.auth.me.invalidate()
    navigate('/', { replace: true })
  }

  function onVerify(v: { pendingToken: string; email: string }) {
    navigate('/verify-email', { state: v })
  }

  return (
    <div className="flex min-h-svh flex-col items-center justify-center bg-muted p-6 md:p-10">
      <div className="w-full max-w-sm md:max-w-3xl">
        <SignupForm onSuccess={onSuccess} onVerify={onVerify} />
      </div>
    </div>
  )
}
